import React from "react";
import CustomCard from "shared/CustomCard";
import Page from "shared/Page";
import RentsetupContainer from "./RentsetupContainer";
import { CustomForm } from "shared/AllInputs";
import EditIcon from "assets/images/icons/editicon.png";
import { useNavigate, useParams } from "react-router-dom";
import { CustomViewInput } from "shared/AllViewInputs";
import BaseRent from "../CommonComponents/BaseRent";
import MaintenanceCost from "../CommonComponents/MaintenanceCost";
import HeatingCost from "../CommonComponents/HeatingCost";
import AdministrativeCost from "../CommonComponents/AdministrativeCost";
import { Accordion, AccordionTab } from "primereact/accordion";

const ViewRentSetupForm = () => {
    const {
        data,
        baseRentData,
        allRents, setAllRents,
        maintenanceCostData,
        allMaintenaceCosts, setAllMaintenanceCosts,
        heatingData,
        allHeatingCosts, setAllHeatingCosts,
        allHeatingDeductionCosts, setAllHeatingDeductionCosts,
        administrativeCost,
        activeIndex, setActiveIndex
    } = RentsetupContainer()

    const navigate = useNavigate()
    const { id } = useParams()

    const header = () => {
        return (
            <div className="flex justify-content-around cursor-pointer">
                <img
                    src={EditIcon}
                    alt=""
                    onClick={() =>
                        navigate(`/rent/edit/${id}`)
                    }
                ></img>
            </div>
        );
    };

    const accordianHeader = (heading) => {
        return (
            <div className="flex align-items-center justify-content-between w-full ">
                <p className="title w-4 text-base">{heading}</p>
            </div>
        );
    };

    return (
        <Page
            title={`View Rent Setup`}
            description={`Let’s View your rent setup Details`}
            navigateLink={"/rent/list"}
        >
            <CustomCard>
                <CustomForm title="Rent" header={header()}>
                    <CustomViewInput name="regulationName" data={data} />
                    <CustomViewInput name="federalState" data={data} />
                    <CustomViewInput name="note" data={data} col={12} />
                </CustomForm>
                <CustomForm title="Tier Controller">
                    <Accordion multiple activeIndex={activeIndex} className="w-full mt-3" onTabChange={(e) => setActiveIndex(e.index)}>
                        <AccordionTab
                            className="mb-3"
                            headerClassName="accordion-role-list"
                            headerTemplate={() => accordianHeader("Base Rent")}
                        >
                            <BaseRent type={"View"} data={baseRentData} allValues={allRents} setAllValues={setAllRents} />
                        </AccordionTab>
                        <AccordionTab
                            className="mb-3"
                            headerClassName="accordion-role-list"
                            headerTemplate={() => accordianHeader("Maintenance Cost")}
                        >
                            <MaintenanceCost type={"View"} data={maintenanceCostData} allValues={allMaintenaceCosts} setAllValues={setAllMaintenanceCosts} />
                        </AccordionTab>
                        <AccordionTab
                            className="mb-3"
                            headerClassName="accordion-role-list"
                            headerTemplate={() => accordianHeader("Heating Cost")}
                        >
                            <HeatingCost
                                type={"View"}
                                data={heatingData}
                                allHeatingCosts={allHeatingCosts}
                                setAllHeatingCosts={setAllHeatingCosts}
                                allHeatingDeductionCosts={allHeatingDeductionCosts}
                                setAllHeatingDeductionCosts={setAllHeatingDeductionCosts}
                            />
                        </AccordionTab>
                        <AccordionTab
                            className="mb-3"
                            headerClassName="accordion-role-list"
                            headerTemplate={() => accordianHeader("Administrative Cost")}
                        >
                            <AdministrativeCost type={"View"} data={administrativeCost} />
                        </AccordionTab>
                    </Accordion>
                </CustomForm>
            </CustomCard>

        </Page >
    )
}

export default ViewRentSetupForm